module.exports = __webpack_public_path__ + "media/svg/vu-8f757fce.svg";